import React from 'react'
import { connect } from 'react-redux'
import EOYTop10 from '~/main/components/EOYTop10'
import { Link } from 'react-router-dom'
import { fetchEOYTop10FullIfNeeded } from '~/features/actions'
import unescape from 'lodash/unescape'

class AnnouncersTopTen extends React.Component {

  componentDidMount(){
    const { match, history, dispatch } = this.props
    dispatch(fetchEOYTop10FullIfNeeded())
  }

  render() {
    const { match, AnnouncersTopTen } = this.props
    let SingleTopTen = []
    if (match && match.params.id && AnnouncersTopTen.full.length ) {
      SingleTopTen = AnnouncersTopTen.full.filter(item => item.path[0].alias === match.url)
    }
    return (
      <div style={{marginBottom: '2em'}}>
        {SingleTopTen.length ?
          SingleTopTen.map( (item, index) => (
            <div id="eoy-top-10" key={index}>
              <h2 className="margin">ZED ANNOUNCERS' TOP TENS FOR 2022<br />{unescape(item.title[0].value)}</h2>
              <div className="list-wrapper margin" >
                <div className="cover">
                  <img src={item.field_image[0].url} alt={item.field_image[0].alt} />
                </div>
                <div className="list">
                  <div dangerouslySetInnerHTML={{__html: item.body[0].value}}></div>
                </div>
                <div style={{clear: 'both'}} />
              </div>
            </div>
        )) :
        <EOYTop10 />
        }

        {
          AnnouncersTopTen.full.map( (item, index) => (
            <div key={index} className="margin" style={{paddingTop: '0.5em'}}>
              <Link to={item.path[0].alias} >{unescape(item.title[0].value)}</Link>
            </div>
          ))
        }
      </div>
    )
  }
}

export default connect( state => ({ AnnouncersTopTen: state.EOYTop10 })) (AnnouncersTopTen)
